var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoldPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.825 0.5C23.075 0.5 25.5 2.9 25.5 7.1625V18.8375C25.5 23.075 23.0875 25.5 18.8375 25.5H7.1625C2.9 25.5 0.5 23.075 0.5 18.8375V7.1625C0.5 2.9 2.9 0.5 7.1625 0.5H18.825ZM12.9875 7.3875C12.4125 7.3875 11.95 7.85 11.95 8.425V11.95H8.4125C8.1375 11.95 7.875 12.0625 7.675 12.25C7.4875 12.45 7.375 12.7112 7.375 12.9875C7.375 13.5625 7.8375 14.025 8.4125 14.0375H11.95V17.575C11.95 18.15 12.4125 18.6125 12.9875 18.6125C13.5625 18.6125 14.025 18.15 14.025 17.575V14.0375H17.575C18.15 14.025 18.6125 13.5625 18.6125 12.9875C18.6125 12.4125 18.15 11.95 17.575 11.95H14.025V8.425C14.025 7.85 13.5625 7.3875 12.9875 7.3875Z",
    fill: "#605BFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldPlus);
export default __webpack_public_path__ + "static/media/bold-plus.530f6ca9e8b9c43c76d61aaf815ab489.svg";
export { ForwardRef as ReactComponent };